/**
 * Build version, shown on the start screen and in the header so a tester can confirm
 * which build they are actually running.
 *
 * GENERATED — do not edit by hand. Run `npm version <patch|minor|major>`, which
 * rewrites this file from package.json via scripts/sync-version.js.
 */
export const BUILD_VERSION = 'v1.6.0';
